import { useContext } from 'react'
import ClientContext from 'contexts/ClientContext'
import classNames from 'classnames'
import style from './Input.module.scss'

const Input = ({
  className,
  darkBg,
  disabled,
  error,
  id,
  label,
  placeholder,
  suffix,
  value,
  type,
  onSuffixClick,
  readOnly,
  register,
  maxLength,
  disallowNumbers,
  disallowLetters,
  disallowSpecials,
  autocomplete,
  allowOnly
}) => {
  const { color, colabelNeutralMid, colabelNeutralDark } = useContext(ClientContext)

  const handleKeyDown = (e) => {
    if (e.key.length === 1 && ((disallowSpecials && !/[a-zA-ZÀ-ÿ-]/.test(e.key)) || (disallowNumbers && /\d/.test(e.key)) || (disallowLetters && !/^[\d]/.test(e.key)) || (allowOnly && !e.key.match(allowOnly)))) {
      e.preventDefault();
    }
  };

  return (
    <div className={classNames(style['input-wrapper'], className, darkBg && style['dark-bg'], error && style.error, color && style.colabel)}>
      <label className={classNames('input-label', darkBg && 'dark-bg')} htmlFor={id} style={color && { color: colabelNeutralDark }}>
        {label}
      </label>
      <div className={style.input}>
        <input
          id={id}
          placeholder={placeholder}
          value={value}
          type={type}
          disabled={disabled}
          readOnly={readOnly}
          maxLength={maxLength}
          {...register}
          onKeyDown={handleKeyDown}
          autoComplete={autocomplete}
          style={color && {
            borderColor: colabelNeutralMid,
            color: colabelNeutralDark
          }}
        />
        {suffix && <div className={style.suffix} onClick={onSuffixClick}>
          {suffix}
        </div>}
      </div>
    </div>
  );
};

export default Input;